import React from 'react';
import PropTypes from 'prop-types';

function Tab({ children }) {
  return <div>{children}</div>;
}

Tab.propTypes = {
  children: PropTypes.element.isRequired,
};

export default Tab;
